import { isSameDay, toDateKey } from "../../utils/date";
import { cx } from "../../utils/classNames";
import {
  formatRecordHours,
  getStatusForDate,
  isOutsideBranch,
  STATUS_LABELS,
} from "./attendanceStatus";
import AwayPin from "./AwayPin";
import { hasApprovedOvertime } from "../overtime/overtimeUtils";
import styles from "./AttendanceView.module.css";
import sessionStyles from "./Sessions.module.css";

const WEEKDAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const AttendanceCalendarView = ({ year, month, days, recordsByDate }) => {
  const today = new Date();
  const leadingBlanks = new Date(year, month, 1).getDay(); // 0 = Sunday

  return (
    <div className={styles.calendarWrapper}>
      <div className={styles.calendarWeekdays}>
        {WEEKDAY_LABELS.map((label) => (
          <span key={label}>{label}</span>
        ))}
      </div>

      <div className={styles.calendarGrid}>
        {Array.from({ length: leadingBlanks }, (_, i) => (
          <div
            key={`blank-${i}`}
            className={cx(styles.calendarCell, styles.isEmpty)}
          />
        ))}

        {days.map((date) => {
          const key = toDateKey(date);
          const status = getStatusForDate(date, recordsByDate);
          const hours = formatRecordHours(recordsByDate[key]);

          return (
            <div
              key={key}
              className={cx(
                styles.calendarCell,
                styles[status],
                isSameDay(date, today) && styles.isToday,
              )}
            >
              <div className={styles.calendarDate}>
                {date.getDate()}
                {isOutsideBranch(recordsByDate[key]) && (
                  <AwayPin title="Checked in or out away from your branch" />
                )}
                {hasApprovedOvertime(recordsByDate[key]) && (
                  <i
                    className="bi bi-stopwatch ms-1 text-primary"
                    title={`Overtime: Yes${
                      recordsByDate[key].overtimeHours > 0
                        ? ` (${formatRecordHours({ workHours: recordsByDate[key].overtimeHours })})`
                        : ""
                    }`}
                    aria-label="Overtime: Yes"
                  ></i>
                )}
                {recordsByDate[key]?.forReviewCount > 0 && (
                  <i
                    className={cx(
                      "bi bi-hourglass-split ms-1",
                      sessionStyles.reviewDot,
                    )}
                    title="Check-in waiting for validation"
                    aria-label="Check-in waiting for validation"
                  ></i>
                )}
              </div>

              <div>
                <div className={styles.calendarStatus}>
                  {STATUS_LABELS[status]}
                </div>
                {hours !== "--" && (
                  <div className={styles.calendarHours}>{hours}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AttendanceCalendarView;
